import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '@/lib/api';

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // Try JWT (localStorage) OR cookie-based Emergent session (sent automatically via credentials)
    try {
      const { data } = await api.get('/auth/me', { withCredentials: true });
      setUser(data);
    } catch {
      setUser(null);
      localStorage.removeItem('access_token');
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password, remember) => {
    const { data } = await api.post('/auth/login', { email, password, remember_me: remember });
    localStorage.setItem('access_token', data.access_token);
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    localStorage.setItem('access_token', data.access_token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await api.post('/auth/logout', {}, { withCredentials: true }); } catch {}
    localStorage.removeItem('access_token');
    setUser(null);
    window.location.href = '/';
  };
  const setAuthUser = (u) => setUser(u);

  return <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh: checkAuth, setAuthUser }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
